import { ROUTE_LOGIN_OUT } from "@/constants/routes.constants";
import { TOKEN_TIME_BEFORE_EXPIRATION } from "@/constants/util.constants";
import { ThemeProvider } from "@/services/ThemeContext/ThemeProvider";
import {
  getTokensLocalStorage,
  isTokenAboutToExpire,
  isTokenExpired,
  requestAndSetTokens,
} from "@/utils/tokens.util";
import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router";

const ProtectedRoute: React.FC = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [isCheckComplete, setIsCheckComplete] = useState(false);

  async function checkUserTokens() {
    const { refreshToken, authToken } = await getTokensLocalStorage();
    if (!authToken || !refreshToken || isTokenExpired(refreshToken)) {
      setIsLoggedIn(false);
      setIsCheckComplete(true);
      return;
    }

    if (isTokenAboutToExpire(authToken)) {
      await requestAndSetTokens(refreshToken);
    }

    setIsLoggedIn(true);
    setIsCheckComplete(true);
  }

  useEffect(() => {
    checkUserTokens();

    const tokenInterval = setInterval(() => {
      checkUserTokens();
    }, TOKEN_TIME_BEFORE_EXPIRATION / 2);

    return () => {
      clearInterval(tokenInterval);
    };
  }, []);

  if (!isCheckComplete) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="border-primary flex h-10 w-10 animate-spin items-center justify-center rounded-full border-4 border-t-4 border-t-transparent"></div>
      </div>
    );
  }

  return isLoggedIn ? (
    <ThemeProvider>
      <Outlet />
    </ThemeProvider>
  ) : (
    <Navigate to={ROUTE_LOGIN_OUT} />
  );
};

export default ProtectedRoute;
